module.exports = __webpack_public_path__ + "img/ponzu-guide.30f5c067.png";